import Immutable from 'immutable';

export default function createEntitiesReducer(key, mergeDeep = false) {
  const initialState = Immutable.Map();

  return function entityReducer(state = initialState, action) {
    const payload = action.payload || {};
    const entities = action.entities || payload.entities;
    const deletedEntities = action.deletedEntities || payload.deletedEntities;

    if (entities || deletedEntities) {
      let updated = state;
      if (deletedEntities) {
        deletedEntities.forEach(entityPath => {
          const [rootKey, ...path] = entityPath.split('.');
          if (rootKey === key) {
            updated = updated.deleteIn(path);
          }
        });
      }

      if (entities && entities[key]) {
        updated = mergeDeep ?
          updated.mergeDeep(entities[key]) :
          updated.merge(entities[key]);
      }

      return updated;
    }

    return state;
  };
}



// WEBPACK FOOTER //
// ./app/reducers/entities/DefaultEntitiesReducer.js